import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import {
  GET_ITINERARY_SEGMENT,
  CLEAR_ITINERARY_SEGMENT,
  FLAG_GETTING_ITINERARY_SEGMENT,
  GET_ITINERARY_INCIDENTS,
  CLEAR_ITINERARY_INCIDENTS,
  FLAG_GETTING_ITINERARY_INCIDENTS,
} from '../types/supervision-control/ItineraryIncident';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import {
  INCIDENT_RECORD_ENDPOINT,
  ITINERARY_ENDPOINT,
} from '../../config/endpoints';
import { flagActivityIncidentRecord } from './IncidentRecord';

const flagGettingItinerarySegment = (flag) => (dispatch) =>
  dispatch({ type: FLAG_GETTING_ITINERARY_SEGMENT, payload: flag });

const getItinerarySegment =
  ({ sourceLocationId, destinationLocationId, dateString }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingItinerarySegment(true));
      const query = QueryString.stringify({
        sourceLocationId,
        destinationLocationId,
        dateString,
      });
      const url = `${ITINERARY_ENDPOINT}/search-by-segment?${query}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const payload = await response.json();
      dispatch({ type: GET_ITINERARY_SEGMENT, payload });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingItinerarySegment(false));
    }
  };

const clearItinerarySegment = () => (dispatch) =>
  dispatch({ type: CLEAR_ITINERARY_SEGMENT });

const flagGettingItineraryIncidents = (flag) => (dispatch) =>
  dispatch({ type: FLAG_GETTING_ITINERARY_INCIDENTS, payload: flag });

const getItineraryIncidents =
  ({ itineraryId, segmentId }) =>
  async (dispatch) => {
    try {
      const query = QueryString.stringify({ itineraryId, segmentId });
      dispatch(flagGettingItineraryIncidents(true));
      const url = `${INCIDENT_RECORD_ENDPOINT}/itinerary?${query}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const payload = await response.json();
      dispatch({ type: GET_ITINERARY_INCIDENTS, payload });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingItineraryIncidents(false));
    }
  };

const clearItineraryIncidents = () => (dispatch) =>
  dispatch({ type: CLEAR_ITINERARY_INCIDENTS });

const postItineraryIncidentRecord =
  ({
    incidentId,
    incidentDate,
    itineraryId,
    segmentId,
    agencyId,
    answerList,
    incidentRecordType,
  }) =>
  async (dispatch) => {
    try {
      const body = {
        incidentId,
        incidentDate,
        itineraryId,
        segmentId,
        agencyId,
        answerList,
        incidentRecordType,
      };
      dispatch(flagActivityIncidentRecord(true));
      const response = await fetch(INCIDENT_RECORD_ENDPOINT, {
        ...DEFAULT_GET_CONFIG,
        method: 'POST',
        body: JSON.stringify(body),
      });
      await isErrorResponse(response, null, dispatch);
      toastr.success('Éxito', 'El registro de incidente se creó correctamente');
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagActivityIncidentRecord(false));
    }
  };

export {
  getItinerarySegment,
  clearItinerarySegment,
  flagGettingItinerarySegment,
  getItineraryIncidents,
  clearItineraryIncidents,
  postItineraryIncidentRecord,
};
